import { render, staticRenderFns } from "./Dictionary.vue?vue&type=template&id=fcc2a41c&scoped=true&"
import script from "./Dictionary.vue?vue&type=script&lang=js&"
export * from "./Dictionary.vue?vue&type=script&lang=js&"
import style0 from "./Dictionary.vue?vue&type=style&index=0&id=fcc2a41c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc2a41c",
  null
  
)

export default component.exports